import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { Text } from '../../common';
import LaunchIcon from './LaunchIcon';

const rules = ({ theme, mini = false }) => ({
  color: 'white',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.fontSize.normal,
  paddingLeft: theme.margin.medium,
  paddingRight: theme.margin.medium,
  gap: theme.margin.fine,
  height: '3.5rem',
  borderRadius: '5px',
  backgroundColor: theme.color.secondaryButtonBackground,
  transition: `background-color ${theme.transition.default}`,
  ':hover': {
    backgroundColor: theme.color.secondaryButtonBackgroundHover,
  },
  extend: [
    {
      condition: mini,
      style: {
        paddingLeft: theme.margin.fine,
        paddingRight: theme.margin.fine,
        height: '2.5rem',
      },
    },
  ],
});

export default function AdLink({ onClick, mini }) {
  const { css } = useFela({ mini });

  return (
    <div className={css(rules)} onClick={onClick}>
      <Text id="visitAd" bold />
      <LaunchIcon />
    </div>
  );
}
AdLink.propTypes = {
  mini: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
